// client/src/components/configuracoes/pagamentos/MetodoPagamentoForm.js
import React, { useState, useEffect } from 'react';
import { useMutateMetodosPagamento } from '../../../hooks/useMetodosPagamento';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../services/api';
import { XCircle } from 'lucide-react';
import { FormStepper, FormStepNavigation } from '../../shared/FormStepper';

const STEP_LABELS = ['Dados da Forma de Pagamento'];

const useGateways = () => {
    return useQuery({
        queryKey: ['gateways'],
        queryFn: async () => {
            // Assumindo que você criará uma rota para listar os gateways ativos
            const { data } = await apiClient.get('/payment-gateways', { params: { isActive: true } });
            return data.data;
        }
    });
};

const MetodoPagamentoForm = ({ current, onSaveSuccess, onCloseForm }) => {
    const [formData, setFormData] = useState({
        nome: '',
        tipo: 'POS_PAGO',
        gateway: '',
        ativo: true,
        instrucoes: ''
    });

    useEffect(() => {
        if (current) {
            setFormData({
                nome: current.nome || '',
                tipo: current.tipo || 'POS_PAGO',
                gateway: current.gateway?._id || '',
                ativo: current.ativo,
                instrucoes: current.instrucoes || ''
            });
        }
    }, [current]);

    const { data: gateways, isLoading: isLoadingGateways } = useGateways();
    const { createMetodo, updateMetodo } = useMutateMetodosPagamento();
    const isLoading = createMetodo.isPending || updateMetodo.isPending;

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = e => {
        e.preventDefault();
        const payload = { ...formData };
        if (payload.tipo === 'POS_PAGO') {
            delete payload.gateway;
        }
        
        if (current) {
            updateMetodo.mutate({ id: current._id, updatedData: payload }, { onSuccess: onSaveSuccess });
        } else {
            createMetodo.mutate(payload, { onSuccess: onSaveSuccess });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <FormStepper currentStep={1} steps={STEP_LABELS} />

            <div className="form-grid-container">
                <div className="form-group">
                    <label htmlFor="nome">Nome</label>
                    <input type="text" name="nome" value={formData.nome} onChange={handleChange} className="form-input" required />
                </div>
                <div className="form-group">
                    <label htmlFor="tipo">Tipo</label>
                    <select name="tipo" value={formData.tipo} onChange={handleChange} className="form-input" disabled={!!current}>
                        <option value="POS_PAGO">Pós-Pago (No Local)</option>
                        <option value="PRE_PAGO">Pré-Pago (Online)</option>
                    </select>
                </div>
                {formData.tipo === 'PRE_PAGO' && (
                     <div className="form-group">
                        <label htmlFor="gateway">Gateway de Pagamento</label>
                        <select name="gateway" value={formData.gateway} onChange={handleChange} className="form-input" disabled={!!current || isLoadingGateways} required>
                            <option value="">{isLoadingGateways ? 'Carregando...' : 'Selecione'}</option>
                            {(gateways || []).map(g => <option key={g._id} value={g._id}>{g.name}</option>)}
                        </select>
                    </div>
                )}
                <div className="form-group">
                    <label htmlFor="instrucoes">Instruções (Opcional)</label>
                    <input type="text" name="instrucoes" value={formData.instrucoes} onChange={handleChange} className="form-input" placeholder="Ex: Pagamento na recepção"/>
                </div>
                 <div className="form-group">
                    <label>
                        <input type="checkbox" name="ativo" checked={formData.ativo} onChange={handleChange} />
                        Ativo
                    </label>
                </div>
            </div>
            <div className="form-actions">
                {onCloseForm && (
                    <button type="button" onClick={onCloseForm} className="action-button action-button-secondary">
                        <XCircle size={18} className="icon" />Cancelar
                    </button>
                )}
                <FormStepNavigation
                    currentStep={1}
                    totalSteps={1}
                    onBack={() => {}}
                    onNext={() => {}}
                    isSubmitting={isLoading}
                    submitLabel="Salvar"
                />
            </div>
        </form>
    );
};

export default MetodoPagamentoForm;